import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

const SEZIONE_COLORS = {
  "corso": "#4CAF50",
  "prossime": "#2196F3",
  "concluse": "#FF9800",
};

function getColor(titolo) {
  const t = titolo.toLowerCase();
  if (t.includes("corso")) return SEZIONE_COLORS["corso"];
  if (t.includes("prossime")) return SEZIONE_COLORS["prossime"];
  if (t.includes("concluse")) return SEZIONE_COLORS["concluse"];
  return "#9E9E9E";
}

export default function Manifestazioni() {
  const [sezioni, setSezioni] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchManifestazioni = () => {
    setLoading(true);
    setError(null);
    axios.get(`${API}/manifestazioni`)
      .then(r => setSezioni(r.data.sezioni || []))
      .catch(() => setError("Impossibile caricare le manifestazioni."))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchManifestazioni(); }, []);

  if (loading) return <div className="manifestazioni-loading" role="status">Caricamento manifestazioni...</div>;
  if (error) return (
    <div className="manifestazioni-error">
      <div className="error-message" role="alert">
        <span>{error}</span>
        <button className="retry-btn" onClick={fetchManifestazioni}>Riprova</button>
      </div>
    </div>
  );

  return (
    <div className="manifestazioni">
      {sezioni.map((sezione, i) => (
        <div key={i} className="sezione-block">
          <h2 className="sezione-titolo" style={{ '--sezione-color': getColor(sezione.titolo) }}>
            {sezione.titolo}
          </h2>
          <div className="manifestazioni-list">
            {sezione.manifestazioni.map((m) => (
              <a
                key={m.id}
                href={m.url}
                target="_blank"
                rel="noopener noreferrer"
                className="manifestazione-card"
              >
                <span className="manifestazione-data">{m.data}</span>
                <span className="manifestazione-nome">{m.nome}</span>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
